import { useState } from 'react';

import {
  GetAssociationLicenseMembersQuery,
  getAssociationLicenseMembers,
} from '@src/api/group/getAssociationLicenseMembers';
import { GetAssociationMembersQuery } from '@src/api/group/getAssociationMembers';
import { useInfiniteQuery } from 'react-query';

function useGetAssociationLicenseMembers(props: Partial<GetAssociationLicenseMembersQuery>) {
  const [total, setTotal] = useState<number>(0);

  const response = useInfiniteQuery(
    ['ASSOCIATION_MEMBERS', props?.page, props.q, props],
    async ({ pageParam: page = 1 }) => {
      const query: GetAssociationMembersQuery = {
        page,
        limit: 10,
        ...props,
      };

      const response = await getAssociationLicenseMembers({ query });

      if (response) setTotal(response.count);

      return response;
    },
    {
      getNextPageParam: (_, pageParam) => {
        const result = pageParam.length + 1;
        return result;
      },
      getPreviousPageParam: (_, pageParam) => {
        const result = pageParam.length - 1;
        return result || 1;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  );

  const data =
    response.data?.pages?.filter(v => v)?.flatMap(data => (data ? data.rows.map(v => v) : [])) ||
    [];

  // console.log('useGET', response, data, total);

  return { ...response, data, total };
}

export default useGetAssociationLicenseMembers;
